import React, { useState } from "react";
import { Input, Modal, AutoComplete, Table, message } from "@cloud/atom-ui";
import "./style.css";
import {
  GetPersonThunk,
  PutPersonThunk,
  DeletePersonThunk,
  DeletGrayPerson,
  addGrayPerson
} from "./thunk";
import SearchOutlined from "@cloud/atom-ui-icons/SearchOutlined";
import { getAppPathFromType } from "@src/utils/common";

/// 弹窗选择人员
/// type：类型 1/2/5内部  3/4第三方
/// userType:用户类型，0责任人 1开发者 2 // 灰度设置可见范围人员
/// onclose:关闭事件
/// appId:应用id
/// selectedData:选择人员列表
/// showModalFlag:是否显隐
export default props => {
  const { userType, onclose, appId, Refresh, seetOrCheckFlag, type } = props; //参数
  const [personList, setPersonList] = useState(props.selectedData); //人员列表
  const [visible, setVisible] = useState(props.showModalFlag); //弹窗显隐
  const [dataSourceShow, setDataShow] = useState([]); //下拉数据
  const [total, setTotal] = useState(null); // 总的人数
  const [curPage, setCurPage] = useState(1); // 当前页数
  //控制
  const config = [
    {
      title: "应用责任人管理",
      label:
        "一个应用最多支持5个责任人，责任人具有相同的权限，都可以维护应用基本信息、发布应用",
      count: 5,
      text: "应用责任人"
    },
    {
      title: "协同开发者管理",
      label:
        "协同开发者可参与开发调试、扫码调试、发布开发包。一个应用最多可添加50个协同开发者。",
      count: 50,
      text: "协同开发者"
    },
    {
      title: "添加人员",
      label: "灰度版本最多添加100人",
      count: 100,
      text: "人员"
    }
  ];

  //自动完成控制
  const autoCompleteConfig = {
    onSearch: async searchText => {
      //检查特殊字符
      const text = searchText.replace(
        /\\|\/|\?|\？|\*|\"|\“|\”|\'|\‘|\’|\<|\>|\{|\}|\[|\]|\【|\】|\：|\:|\、|\^|\$|\!|\~|\`|\||\#|\%|\&|\-|\_/g,
        ""
      );
      if (text == "" || text == " ") {
        setDataShow([]);
        return;
      }
      const res = await GetPersonThunk(text);
      if (res.status == 1) {
        setDataShow(
          res.data.map(obj => `${obj.accountNameCn}【${obj.accountId}】`)
        );
      } else {
        message.error(res.errMsg);
        setDataShow([]);
      }
    },
    onChange: async value => {
      const name = value.split("【")[0];
      const id = value.split("【")[1].replace("】", "");
      if (userType === 2) {
        if (personList.length >= 100) {
          message.warning("应用下已存在100个人员,不能再添加了!");
        } else {
          const res = await addGrayPerson(appId, { accounts: [id] });
          //  调用 灰度 添加人员接口
          handleAddPerson(res, name, id);
        }
      } else {
        const res = await PutPersonThunk(
          appId,
          { accounts: [id], memberType: userType },
          getAppPathFromType(type)
        );
        //  调用添加人员接口
        handleAddPerson(res, name, id);
      }
    }
  };
  const handleAddPerson = (res, name, id) => {
    if (res.status == 1) {
      let list = personList;
      list.push({
        chineseName: name,
        accountId: id
      });
      setPersonList([...list]);
      setDataShow([]);
      return "";
    } else {
      message.error(res.errMsg);
    }
  };

  //  删除数据
  const deletPerson = (res, accountId) => {
    if (res.status == 1) {
      //删除数据
      let list = personList;
      const index = list.findIndex(item => accountId === item.accountId);
      list.splice(index, 1);
      setPersonList([...list]);
    } else {
      message.error(res.errMsg);
    }
  };

  //删除人员
  const tableDelete = async (value, accountId) => {
    if (personList.length == 1) {
      message.warning("至少保留一位人员");
      return;
    }
    if (userType === 2) {
      if (personList.length > 1) {
        const res = await DeletGrayPerson(appId, {
          accounts: [value.accountId]
        });
        deletPerson(res, accountId);
      } else {
        message.warning("至少保留一位人员");
      }
    } else {
      const res = await DeletePersonThunk(
        appId,
        { account: value.accountId, memberType: userType },
        getAppPathFromType(type)
      );
      deletPerson(res, accountId);
    }
  };
  //  获取当前页数
  const onPageChange = value => {
    setCurPage(value && value.current);
  };

  //表格列定义
  const columns = [
    {
      title: "姓名",
      dataIndex: "chineseName",
      key: "chineseName",
      with: "100px",
      render: (text, record, index) => (
        <div className={"member-name"}>{record.chineseName}</div>
      )
    },
    {
      title: "账号",
      dataIndex: "accountId",
      key: "accountId",
      render: (text, record, index) => (
        <div className={"member-account"}>{record.accountId}</div>
      )
    },

    {
      title: "操作",
      dataIndex: "tags",
      key: "tags",
      render: (text, record, index) => (
        <span
          onClick={() => tableDelete(record, record.accountId)}
          style={{ cursor: "pointer" }}
        >
          删除
        </span>
      )
    }
  ];
  const columns2 = [
    {
      title: "姓名",
      dataIndex: "chineseName",
      key: "chineseName"
    },
    {
      title: "账号",
      dataIndex: "accountId",
      key: "accountId"
    }
  ];
  return (
    <Modal
      title={seetOrCheckFlag == 2 ? "查看人员" : config[userType].title}
      visible={visible}
      width={616}
      onCancel={() => {
        setVisible(!visible);
        onclose();
        Refresh && Refresh(true);
      }}
      maskClosable={false}
      footer={null}
    >
      {seetOrCheckFlag == 2 ? null : (
        <>
          <label className="personModal_title">{config[userType].label}</label>
          <AutoComplete
            className="personModal_search"
            dataSource={dataSourceShow}
            onSelect={value => autoCompleteConfig.onChange(value)}
            onSearch={autoCompleteConfig.onSearch}
            defaultActiveFirstOption={false}
          >
            <Input
              allowClear={true}
              className={"searchInput"}
              suffix={<SearchOutlined className="certain-category-icon" />}
              size="small"
              placeholder="请输入姓名进行查询"
            />
          </AutoComplete>
          <label className="personModal_count">
            还可添加{config[userType].count - personList.length}个
            {config[userType].text}
          </label>
        </>
      )}
      <Table
        dataSource={personList}
        columns={seetOrCheckFlag == 2 ? columns2 : columns}
        pagination={{
          style: { margin: "8px" },
          total: total,
          showTotal: total => `共 ${total} 条`,
          showQuickJumper: true,
          showSizeChanger: true,
          current: curPage
        }}
        onChange={pageIndex => {
          onPageChange(pageIndex);
        }}
      />
    </Modal>
  );
};
